<!--  -->
<template>
  <div class="breadcrumb">
    <div class="gan left"></div>
    <div class="left title">{{ t2 }}</div>

    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }"><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item
        ><a :href="href">{{ t1 }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ t2 }}</el-breadcrumb-item>
    </el-breadcrumb> -->
  </div>
</template>
    
<script>
import { constantRouterMap } from "@/router";
export default {
  data() {
    return {
      t1: "",
      t2: "",
      href: "/",
    };
  },

  components: {},

  computed: {},

  created() {
    this.routerList = constantRouterMap.filter((item) => item.isMenu);
    let { path } = this.$route;
    let _array = path.split("/");
    this.routerList.forEach((item) => {
      if (item.menuName == _array[1]) {
        this.href = item.path;
        this.t1 = item.title;
        if (item.children) {
          item.children.forEach((it) => {
            if (it.menuName == _array[2]) {
              this.t2 = it.title;
            }
          });
        }
      }
    });
  },

  methods: {},
};
</script>
<style scoped lang="scss">
.breadcrumb {
  width: 100%;
  height: 55px;

  text-align: left;
  /* padding-left: 20px; */
  padding-top: 22px;
  /* padding: 0 20px; */
  box-sizing: border-box;
  /* box-shadow: 0px 3px 5px rgba(0, 0, 0 , .1); */
  .gan {
    width: 0;
    height: 16px;
    margin-top: 3px;
    border-right: 2px solid blue;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    margin-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue